export default __webpack_public_path__ + "img/facebook.0a49fec36c794bf633ec225fcd6bc5bf.svg";